var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGroupProfile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#F2F4F7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.0001 19.1974C22.2134 19.8069 23.2536 20.785 24.0128 22.008C24.1632 22.2502 24.2383 22.3713 24.2643 22.539C24.3172 22.8798 24.0841 23.2988 23.7667 23.4336C23.6105 23.5 23.4348 23.5 23.0834 23.5M19.3334 15.6102C20.5682 14.9966 21.4168 13.7224 21.4168 12.25C21.4168 10.7776 20.5682 9.50343 19.3334 8.8898M17.6668 12.25C17.6668 14.3211 15.9878 16 13.9168 16C11.8457 16 10.1668 14.3211 10.1668 12.25C10.1668 10.1789 11.8457 8.5 13.9168 8.5C15.9878 8.5 17.6668 10.1789 17.6668 12.25ZM8.1328 21.782C9.46139 19.7871 11.5579 18.5 13.9168 18.5C16.2756 18.5 18.3722 19.7871 19.7008 21.782C19.9918 22.219 20.1373 22.4375 20.1206 22.7166C20.1075 22.9339 19.9651 23.2 19.7914 23.3313C19.5684 23.5 19.2616 23.5 18.6481 23.5H9.18541C8.57192 23.5 8.26517 23.5 8.04214 23.3313C7.86848 23.2 7.72601 22.9339 7.71297 22.7166C7.69622 22.4375 7.84174 22.219 8.1328 21.782Z",
    stroke: "#475467",
    strokeWidth: 1.125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroupProfile);
export default __webpack_public_path__ + "static/media/GroupProfile.35b8d8e3d12810eac732507bff127fa4.svg";
export { ForwardRef as ReactComponent };